<div class="tv">
    <div class="tv-toolbar">
        <div class="tv-search">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control form-control-sm" placeholder="search"
                   [(ngModel)]="query" (ngModelChange)="apply()">
            <button type="button" class="btn btn-sm btn-link tv-clear" *ngIf="query" (click)="clear()">
                <i class="fa fa-times"></i>
            </button>
        </div>

        <div class="form-check tv-check">
            <input class="form-check-input" type="checkbox" id="tvOnlyMatches"
                   [(ngModel)]="onlyMatches" (ngModelChange)="apply()">
            <label class="form-check-label" for="tvOnlyMatches">only matches</label>
        </div>

        <span class="tv-stat" *ngIf="query">{{ matchCount }} matches</span>
        <span class="tv-stat">{{ totalLines }} lines</span>

        <div class="tv-actions">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copy()" title="Copy everything">
                <i class="fa fa-copy"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="download()" title="Download as file">
                <i class="fa fa-download"></i>
            </button>
        </div>
    </div>

    <div class="tv-body" #tvBody [class.tv-wrap]="wrap" (scroll)="onBodyScroll()">
        <div class="tv-line" *ngFor="let line of lines; trackBy: trackLine" [class.tv-match]="line.match">
            <span class="tv-num">{{ line.number }}</span>
            <span class="tv-text">{{ line.text }}</span>
        </div>
    </div>

    <div class="tv-note" *ngIf="truncated">
        Showing the first {{ lines.length }} lines only — download the file to read all of it.
    </div>
</div>
